import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTooltip,{attrs:{"bottom":"","open-delay":500},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({attrs:{"dark":"","icon":""},on:{"click":function($event){return _vm.mudarEstadoDialog()}}},'v-btn',attrs,false),on),[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-bell-off")])],1)]}}])},[_c('span',[_vm._v("Silenciar todos os produtos do fornecedor")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }